
<template>
  <div class="complainant_info">
    <el-form :model="ruleForm" :rules="rules" class="ruleForm" label-width="250px" ref="ruleForm"
> 
      <el-form-item label="企业名称：" prop="businessName" class="double-row">
<!--        <el-input v-model="ruleForm.businessName" v-show="isEditor"></el-input>-->
<!--        <input type="text" v-model="ruleForm.businessName" v-show="!isEditor"/>-->
        <span >{{ruleForm.complaintFounderVo&&ruleForm.complaintFounderVo.entName }}</span>
      </el-form-item>
      <el-form-item label="统一社会信用代码：" prop="complaintNumber" class="double-row">
        <span >{{ruleForm.complaintFounderVo&&ruleForm.complaintFounderVo.legalCode }}</span>
      </el-form-item>
      <el-form-item label="企业法定代表人：" prop="corporateRepresentative" class="double-row">
        <span >{{ruleForm.complaintFounderVo&&ruleForm.complaintFounderVo.legalAgentor }}</span>
      </el-form-item>
      <el-form-item label="法定代表人身份证号码：" prop="corporateRepresentativeCode" class="double-row">
        <span >{{ruleForm.complaintFounderVo&&ruleForm.complaintFounderVo.legalAgentorCode }}</span>
      </el-form-item>
      <el-form-item label=" 投诉人：" prop="complainants" class="double-row">
        <span >{{ruleForm.complaintFounderVo&&ruleForm.complaintFounderVo.complainter }}</span>
      </el-form-item>
      <el-form-item label=" 投诉人联系方式：" prop="complainantsPhone" class="double-row">
        <span >{{ruleForm.complaintFounderVo&&ruleForm.complaintFounderVo.complainterPhone }}</span>
      </el-form-item>
      <el-form-item label=" 投诉人身份证号码：" prop="complainantsCard" class="double-row">
        <span >{{ruleForm.complaintFounderVo&&ruleForm.complaintFounderVo.complainterCode }}</span>
      </el-form-item>
      <el-form-item label=" 投诉人邮箱：" prop="complainantsPhone" class="double-row">
        <span >{{ruleForm.complaintFounderVo&&ruleForm.complaintFounderVo.complainterEmail }}</span>
      </el-form-item>
      <el-form-item label=" 投诉受理部门：" prop="complainantsPhone" class="double-row">
        <span >{{ruleForm.complaintFounderVo&&ruleForm.complaintFounderVo.receiverOrgName }}</span>
      </el-form-item>
      <el-form-item label=" 投诉人地址：" prop="complainantsAddress" class="single-row">
        <span >{{ruleForm.complaintFounderVo&&ruleForm.complaintFounderVo.complainterAddress }}</span>
      </el-form-item>
      <el-form-item label=" 投诉渠道：" prop="complainantChannels" class="single-row">
        <span >{{ruleForm.complaintFounderVo&&ruleForm.complaintFounderVo.sourceTypeName }}</span>
      </el-form-item>
    </el-form>

  </div>

</template>
<script>
export default {
  props:['ruleForm'],
  data() {
    return {
      // ruleForm: {
      //   businessName: JSON.parse(sessionStorage.getItem("oneliner")).objectionName,
      //   complaintNumber: JSON.parse(sessionStorage.getItem("oneliner")).complaintNumber,
      //   corporateRepresentative:"黄贤辉",
      //   corporateRepresentativeCode:"140430189008020011",
      //   complainantsPhone:"15757124596",
      //   complainantsCard:"140430189008020011",
      //   complainantsMail:"940380800@qq.com",
      //   complainants:"黄贤辉",
      //   objectionTime:JSON.parse(sessionStorage.getItem("oneliner")).objectionTime,
      //   complainantsAddress:'上海市青浦区华隆路 1777号E 通世界华新园G 栋 2F',
      //   complainantChannels:'黄石市公共资源交易平台'
      // },
      rules: {
        businessName: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
        complaintNumber: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
        corporateRepresentative: [{ required: true, message: '请输入企业法定代表人', trigger: 'blur' }],
        corporateRepresentativeCode: [{ required: true, message: '请输入法定代表人身份证号码', trigger: 'blur' }],
        complainants: [{ required: true, message: '请输入投诉人', trigger: 'blur' }],
        complainantsPhone: [{ required: true, message: '请输入投诉人联系方式', trigger: 'blur' }],
        complainantsCard: [{ required: true, message: '请输入投诉人身份证号码', trigger: 'blur' }],
        complainantsMail: [{ required: true, message: '请输入投诉人邮箱', trigger: 'blur' }],
        processResult:[{required:true, message:'请输入投诉结果',trigger:'blur'}],
        complainantChannels:[{required:true, message:'请输入投诉渠道',trigger:'blur'}],

      }
    };
  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.complainant_info {
.ruleForm{
  display: flex;flex-wrap: wrap;justify-content: space-between;
  width: 100%;
}
  .el-dialog__wrapper /deep/ .el-dialog__header {
  }

  .el-dialog__wrapper /deep/ .el-dialog__body {
    padding: 10px 20px;
  }

  .el-form /deep/ .el-form-item.single-row {
    width: 100%;
    margin-bottom:20px;
  }

  .el-form /deep/ .el-form-item.double-row {
    width: 50%;
    margin-bottom:20px;
  }

  .el-form /deep/ .el-form-item {
    .el-form-item__label, .el-form-item__content {
      line-height: 26px;
    }
  }

  .el-form /deep/ .el-form-item {
    width: 50%;
    margin-bottom: 0px;
  }

  .el-form /deep/ .el-form-item.searchInForm {
    width: auto;
    margin-bottom: 10px;

    .el-form-item__label {
      line-height: 32px;
    }
  }

  .el-dialog__wrapper /deep/ .el-dialog__footer {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .link:hover {
    cursor: pointer; //鼠标变手
    /*background-color: #1890FF; //链接变颜色*/
    /*color: white!important;*/
  }
}

</style>
